<template>
  <!-- <q-scroll-area class="full-height full-width"> -->
  <q-scroll-area style="height: calc(100vh - 100px);">
    <div class="q-pa-sm">
      <div class="row">
        <div v-if="show_sell_order" class="">
          <div class="text-h6 text-bold">客户订单逾期记录</div>
          <div>
            <TablePanel style="width: 100%;" :table_height_param="300" :table_heigh="300" :menu_data="menu_data"
              :is_detail="1" :is_audited="0" :search_data="0" :detail_table_total="detail_table_total"
              :detail_table_data="detail_table_data" :show_level="1" :currentPage="1" :total_row="999999" :is_export="0"
              :export_data="export_data" :is_home_option="1" :show_option="0" />
          </div>
        </div>

        <div v-if="show_material_stock" class="q-pt-md">
          <div class="text-h6 text-bold">材料库存预警记录</div>
          <div>
            <TablePanel style="width: 100%;" :table_height_param="300" :table_heigh="300" :menu_data="menu_data2"
              :is_detail="1" :is_audited="0" :search_data="0" :detail_table_total="detail_table_total"
              :detail_table_data="detail_table_data2" :show_level="1" :currentPage="1" :total_row="999999"
              :is_export="0" :export_data="export_data" :is_home_option="1" :show_option="0" />
          </div>
        </div>
      </div>
    </div>
  </q-scroll-area>
</template>

<script>
import { ref } from 'vue';
import { useQuasar } from "quasar";
import { request } from "@/request/api";
import { useI18n } from "vue-i18n";

import TablePanel from "../template/components/TablePanel.vue";

export default {
  name: 'MyHome',
  components: {
    TablePanel,
  },
  setup() {
    const $q = useQuasar();
    const { t } = useI18n();
    const menu_data = ref({
      'table_name': 't_sell_order_home',
      'menu_name': 'sell_order_home',
    })

    const menu_data2 = ref({
      'table_name': 't_material_stock_home',
      'menu_name': 'material_stock_home',
    })

    const show_sell_order = ref(false);
    const show_material_stock = ref(false);

    let permission = $q.localStorage.getItem("permission");

    if (permission !== 'undefined') {
      show_sell_order.value = permission.hasOwnProperty('sell_order');
      show_material_stock.value = permission.hasOwnProperty('material_stock');
    }

    const detail_table_data = ref({}); // 明细表格数据
    const detail_table_data2 = ref({}); // 明细表格数据

    function get_data() {
      $q.loading.show();

      request("get_list_data", {
        table_name: 't_sell_order_home',
        search_data: { 'overdue': 1 },
        is_fuzzy_query: 0,
        current_page: 1,
        page_size: 99999,
        sort_field: 'delivery_date',
        sort_order: '',
        menu_name: 'sell_order_home',
      }).then((res) => {
        detail_table_data.value = res[1];
      });

      request("get_list_data", {
        table_name: 't_material_stock_home',
        search_data: { 'stock_alert': 1 },
        is_fuzzy_query: 0,
        current_page: 1,
        page_size: 99999,
        sort_field: '',
        sort_order: '',
        menu_name: 'material_stock_home',
      }).then((res) => {
        detail_table_data2.value = res[1];

        $q.loading.hide();
      });
    }

    get_data();

    return {
      t,
      show_sell_order,
      show_material_stock,
      menu_data,
      menu_data2,
      detail_table_data,
      detail_table_data2,
    }
  }
}
</script>